export default "/images/program-logo.png?c4dbe3faca502b241cbe33fd7b18decf";